/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import type { IconProps } from './types/index';

function IcMoreHorizontalRegular({ className, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 24 24"
      className={`kc-console-icon ${className ? className : ''}`}
      {...props}
    >
      <path d="M4.5 10a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5m7.5 0a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5m9.25 1.75a1.75 1.75 0 1 0-3.5 0 1.75 1.75 0 0 0 3.5 0" />
    </svg>
  );
}
export default IcMoreHorizontalRegular;
